import CompleteModal from 'components/CompleteModal/CompleteModal';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from '../../messages';

const PendingView = ({ onComplete }: { onComplete: () => void }) => {
  const { language } = useSelector((state: RootState) => state.language);
  const viewMessages = messages[language].verifyingAccount;

  return (
    <div>
      <CompleteModal
        heading={viewMessages.heading}
        subheading={viewMessages.subheading}
        continueButton={viewMessages.continueButton}
        onComplete={onComplete}
      />
    </div>
  );
};

export default PendingView;
